/**
 * Funciones base para generar enlaces y mensajes de WhatsApp
 * Estas funciones son reutilizables por todos los módulos del sistema
 */

export function generateWhatsAppLink(phoneNumber: string, message: string): string {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
}

export function generateShareWhatsAppLink(message: string): string {
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?text=${encodedMessage}`;
}

export function encodeWhatsAppMessage(message: string): string {
  return encodeURIComponent(message);
}
